"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const notistack_1 = require("notistack");
const material_ui_confirm_1 = require("material-ui-confirm");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const wrapper_component_1 = require("@/room/room_create/wrapper_component");
const _1 = require(".");
function default_1() {
    const roomData = (0, react_redux_1.useSelector)((state) => state.roomData);
    const { id: roomId, img_url: mainPhoto, title: roomTitle, category, fee_free: isFeeFree, refund_policy: refundPolicy, room_type: roomType, support_delivery_date: supportDeliveryDate, } = roomData;
    const isRegularForm = roomType === '굿즈' || roomType === '서포트';
    const isPayform = isRegularForm && !isFeeFree;
    const isPromiseForm = isRegularForm && isFeeFree;
    const regularSales = (0, react_redux_1.useSelector)((state) => state.regularSales);
    const deliveryType = (0, react_redux_1.useSelector)((state) => state.deliveryType);
    const freeDeliveries = (0, react_redux_1.useSelector)((state) => state.freeDeliveries);
    const fixedDeliveries = (0, react_redux_1.useSelector)((state) => state.fixedDeliveries);
    const additionalDeliveries = (0, react_redux_1.useSelector)((state) => state.additionalDeliveries);
    const conditionalDeliveries = (0, react_redux_1.useSelector)((state) => state.conditionalDeliveries);
    const diffDeliveries = (0, react_redux_1.useSelector)((state) => state.diffDeliveries);
    const customDeliveries = (0, react_redux_1.useSelector)((state) => state.customDeliveries);
    const delete_deliveries = (0, react_redux_1.useSelector)((state) => state.delete_deliveries);
    const productData = (0, react_redux_1.useSelector)((state) => state.productData);
    const originProductData = (0, react_redux_1.useSelector)((state) => state.originProductData);
    const keepingRefundPolicy = (0, react_redux_1.useSelector)((state) => state.keepingRefundPolicy);
    const originRefundPolicy = (0, react_redux_1.useSelector)((state) => state.originRefundPolicy);
    const { is_question, questions } = roomData;
    const delete_questions = (0, react_redux_1.useSelector)((state) => state.delete_questions);
    const { is_secret, secret_password, secret_hint } = roomData;
    const { t } = (0, react_i18next_1.useTranslation)();
    const isEdit = (0, react_redux_1.useSelector)((state) => state.isEdit);
    const isCloneRoom = (0, react_redux_1.useSelector)((state) => Boolean(state.roomData.original_room));
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const validateRoomSubmit = () => __awaiter(this, void 0, void 0, function* () {
        setIsSubmitting(true);
        if (!isEdit) {
            //! 다른 탭에서 등록완료 되어있는 폼인지 확인하기 위해
            yield (0, api_1.getData)(`/api/v1/store/room/${roomId}`)
                .then(res => {
                if (res.status === 200) {
                    if (res.data.result.isValid) {
                        window.onbeforeunload = null;
                        (0, functions_1.showToastMessage)({ message: `${t('등록한 폼으로 이동할게요')}:)` });
                        setTimeout(() => window.location.replace(`/room/room_view/?room_id=${roomId}`), 3000);
                    }
                    else {
                        submitRoomData();
                    }
                }
            })
                .catch(err => {
                const { status } = err.response;
                (0, _1.handleRoomCreateError)({ status, confirm, isCloneRoom });
                setIsSubmitting(false);
            });
        }
        else {
            submitRoomData();
        }
    });
    const generateErrors = () => {
        let errors = [];
        const mainPhotoError = (0, _1.validateRoomMainPhoto)(mainPhoto);
        if (mainPhotoError)
            errors.unshift(mainPhotoError);
        const titleError = (0, _1.validateRoomTitle)({ roomTitle });
        if (titleError)
            errors.unshift(titleError);
        const categoryError = (0, _1.validateRoomCategory)(category);
        if (categoryError)
            errors.unshift(categoryError);
        const supportDeliveryDateError = (0, _1.validateSupportDeliveryDate)({
            supportDeliveryDate,
            regularSales,
        });
        if (supportDeliveryDateError)
            errors.unshift(supportDeliveryDateError);
        const deliveryError = (0, _1.validateDeliveryData)(deliveryType, fixedDeliveries, conditionalDeliveries, diffDeliveries, customDeliveries);
        if (deliveryError)
            errors.unshift(deliveryError);
        const productError = (0, _1.validateProductData)({ productData, isPromiseForm });
        if (productError)
            errors.unshift(productError);
        const refundPolicyError = (0, _1.validateRefundPolicy)(refundPolicy);
        if (refundPolicyError)
            errors.unshift(refundPolicyError);
        const questionError = (0, _1.validateQuestionData)({ is_question, questions });
        if (questionError)
            errors.unshift(questionError);
        if (isPayform && is_secret) {
            const secretFormErrorArr = (0, _1.validateSecretFormData)({ secret_password, secret_hint });
            errors.unshift(...secretFormErrorArr);
        }
        return errors;
    };
    const generateUpdates = () => {
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (0, _1.generateRoomData)({ roomData, isEdit })), (0, _1.generateDeliveryData)({
            deliveryType,
            freeDeliveries,
            fixedDeliveries,
            additionalDeliveries,
            conditionalDeliveries,
            diffDeliveries,
            customDeliveries,
            delete_deliveries,
        })), { 
            // ? "products: undefined" will be removed automatically by Axios during the serialization process
            products: (0, _1.generateProductData)({ originProductData, productData, isPromiseForm }), refund_policy: (0, _1.generateRefundPolicy)(refundPolicy) }), (0, _1.generateQuestionData)({ is_question, questions, delete_questions })), (0, _1.generateSecretFormData)({ isPromiseForm, is_secret, secret_password, secret_hint }));
    };
    const { enqueueSnackbar, closeSnackbar } = (0, notistack_1.useSnackbar)();
    const snackbarOptions = {
        variant: 'warning',
        autoHideDuration: 99999,
        onClick: () => closeSnackbar(),
    };
    const dispatch = (0, react_redux_1.useDispatch)();
    const submitRoomData = () => __awaiter(this, void 0, void 0, function* () {
        const errorsArr = generateErrors();
        if (errorsArr.length) {
            errorsArr.forEach((errorMsg) => enqueueSnackbar(errorMsg, snackbarOptions));
            setIsSubmitting(false);
        }
        else {
            const updates = generateUpdates();
            if (isPayform) {
                const isPayformZeroTotalPossible = (0, _1.validatePayformZeroTotal)({
                    productData,
                    deliveryData: updates.deliveries,
                });
                if (isPayformZeroTotalPossible) {
                    confirm({
                        description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [`${t('작품 가격이 0원이라면')},`, (0, jsx_runtime_1.jsx)("br", {}), `${t('배송비는 100원 이상 가능해요')}.`, (0, jsx_runtime_1.jsx)("br", {}), `${t('배송비를 입력해주세요')}.`] })),
                        cancellationButtonProps: { style: { display: 'none' } },
                    });
                    return setIsSubmitting(false);
                }
            }
            yield (0, _1.saveRefundPolicy)({ isEdit, keepingRefundPolicy, refundPolicy, originRefundPolicy })
                .then(() => __awaiter(this, void 0, void 0, function* () {
                yield (0, api_1.patchData)(`/api/v1/store/room/${roomId}`, updates).then(res => {
                    if (res.status === 200) {
                        window.onbeforeunload = null;
                        isEdit
                            ? window.location.replace(`/room/room_manager/?roomId=${roomId}`)
                            : isCloneRoom
                                ? window.location.replace('/room/history')
                                : window.location.replace(`/room/room_view/?room_id=${roomId}`);
                    }
                });
            }))
                .catch(err => {
                const { status } = err.response;
                (0, _1.handleRoomCreateError)({ status, confirm });
                setIsSubmitting(false);
            });
        }
    });
    const roomCreateStep = (0, react_redux_1.useSelector)((state) => state.roomCreateStep);
    const isPreview = roomCreateStep === 'preview';
    const handlePreview = () => {
        if (isPreview) {
            dispatch((0, roomCreateStore_1.setRoomCreateStep)('2'));
        }
        else {
            dispatch((0, roomCreateStore_1.setRoomCreateStep)('preview'));
            window.scrollTo(0, 0);
        }
    };
    const isSecondStep = roomCreateStep === '2';
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const isEditOrCloneRoom = isEdit || isCloneRoom;
    const isSecondStepPC = !maxWidth768 && isSecondStep;
    const isEditOrCloneSecondStepPC = isSecondStepPC && isEditOrCloneRoom;
    return ((0, jsx_runtime_1.jsxs)(wrapper_component_1.SubmitButtonWrapper, Object.assign({ isSticky: isEditOrCloneRoom, isPCView: isSecondStepPC, isFixedPCView: isEditOrCloneSecondStepPC }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: handlePreview, sx: {
                    border: '1px solid var(--gray-10)',
                    bgcolor: 'var(--white) !important',
                    color: 'var(--gray-80)',
                } }, { children: isPreview ? (0, jsx_runtime_1.jsx)("span", { children: t('다시 수정') }) : (0, jsx_runtime_1.jsx)("span", { children: t('미리 보기') }) })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: validateRoomSubmit, disabled: isSubmitting, sx: {
                    bgcolor: 'var(--primary-main) !important',
                    color: 'var(--white)',
                    fontWeight: 'bold',
                } }, { children: isSubmitting ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "info", thickness: 8 })) : isEdit ? ((0, jsx_runtime_1.jsx)("span", { children: t('수정 완료') })) : isCloneRoom ? ((0, jsx_runtime_1.jsx)("span", { children: t('복제 완료') })) : ((0, jsx_runtime_1.jsx)("span", { children: t('등록 완료') })) }))] })));
}
exports.default = default_1;
